import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { ApiService } from '../services/api/api.service';
import { combineLatest } from 'rxjs';
import { icon } from 'leaflet';

@Component({
    standalone: false,
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
    dashboardItems: any[] = [];
    adminItems: any[] = [];
    organisationItems: any[] = [];
    inputItems: any[] = [];
    outputItems: any[] = [];
    searchItems: any[] = [];

    documentsCount: any;
    documentsDone: any;
    documentsProcessing: any;
    tags: any;
    taxonomies: any;
    dates: any;
    users: any;
    companies: any;
    currentUser: any;

    currentCompany: any;

    isLoading: boolean = true;

    constructor(
        public layoutService: LayoutService,
        private apiService: ApiService
    ) { }

    ngOnInit() {

        this.currentUser = this.apiService.currentUser;
        this.setMenu();
        this.isLoading = false;
        if (!this.currentUser) {
            this.apiService.currentUserChange.subscribe((user) => {
                this.currentUser = user;
                this.currentCompany = localStorage.getItem('currentCompany') ? JSON.parse(localStorage.getItem('currentCompany')) : null;


                if (this.adminItems.length){
                    this.adminItems[0].items.find(item => item.label == 'Organisations').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false;
                    this.adminItems[0].items.find(item => item.label == 'Bases').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false;
                    this.adminItems[0].items.find(item => item.label == 'Tous les agents').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false;
                    this.adminItems[0].items.find(item => item.label == 'Tous les prompts').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false;
                    this.adminItems[0].items.find(item => item.label == 'Utilisateurs').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false;
                    this.adminItems[0].items.find(item => item.label == 'Utilisateurs en attente').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false;
                    this.adminItems[0].items.find(item => item.label == 'Réglages').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isAdmin') == "true") ? true : false;
                    this.adminItems[0].items.find(item => item.label == 'Consommation').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isAdmin') == "true") ? true : false;
                
                    this.adminItems[0].items.find(item => item.label == 'Votre profil').visible = this.currentUser && this.currentUser.companies.length ? true : false;
                    
                }

                if (this.organisationItems.length) {
                    this.organisationItems[0].items.find(item => item.label == 'Mon organisation').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSupervisor') == "true") ? true : false;
                    this.organisationItems[0].items.find(item => item.label == 'Mes utilisateurs').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSupervisor') == "true") ? true : false;
                    this.organisationItems[0].items.find(item => item.label == 'Mes bases de connaissance').visible = this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSupervisor') == "true") ? true : false;
                    this.organisationItems[0].items.find(item => item.label == 'Mes bases').visible = this.currentUser && (this.currentUser.organisations.length) ? true : false;
                }

                // if (user.organisations.length === 0) {
                //     this.organisationItems = []
                // }

                // Temporairement, montrer la partie organisation que si superadmin ou superviseur
                if (!(this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSupervisor') == "true"))){
                    this.organisationItems = []
                }


                if (this.dashboardItems.length) {
                    this.dashboardItems[0].items.find(item => item.label == 'Dashboard').visible = this.currentUser && this.currentUser.companies.length ? true : false;
                }


                if (this.searchItems.length) {
                    this.searchItems[0].items.find(item => item.label == 'Tags').visible = this.currentUser && this.currentUser.companies.length ? true : false;
                    this.searchItems[0].items.find(item => item.label == 'Catégories').visible = this.currentUser && this.currentUser.companies.length ? true : false;
                    this.searchItems[0].items.find(item => item.label == 'Dates').visible = this.currentUser && this.currentUser.companies.length ? true : false;
                }

                if (this.outputItems.length) {
                    this.outputItems[0].items.find(item => item.label == 'Poser une question').visible = this.currentUser && this.currentUser.companies.length ? true : false;
                    this.outputItems[0].items.find(item => item.label == 'Actions').visible = this.currentUser && (this.currentUser.is_superadmin || (this.currentCompany && this.currentCompany.organisation_id)) ? false : true;
                }
            
                if (localStorage.getItem('isSupervisor') == "true" && !localStorage.getItem('currentCompany') && localStorage.getItem('isSuperAdmin') != "1") {
                    this.dashboardItems = []
                    this.inputItems = []
                    this.outputItems = []
                    this.searchItems = []
                    this.adminItems = []
                }



                this.setMenu();
                this.isLoading = false;
            });
        }

        this.documentsCount = this.apiService.documentsCount;
        if (this.documentsCount) {
            this.documentsDone = this.documentsCount.done;
            this.documentsProcessing = this.documentsCount.processing;
        }
        this.apiService.documentsChanges.subscribe((data) => {
            this.documentsCount = data;
            if (this.documentsCount) {
                this.documentsDone = this.documentsCount.done;
                this.documentsProcessing = this.documentsCount.processing;
            } else {
                this.documentsDone = 0;
                this.documentsProcessing = 0;
            }

            this.inputItems[0].items.find(item => item.label == 'Importer un document').badge = this.documentsProcessing;
            this.searchItems[0].items.find(item => item.label == 'Documents').badge = this.documentsDone;
        });

        // this.currentCompany = localStorage.getItem('currentCompany') ? JSON.parse(localStorage.getItem('currentCompany')) : null;
        // if (this.currentCompany) {
        //     this.outputItems[0].items.find(item => item.label == 'Actions').visible = this.currentCompany.organisation_id ? false : true;
        // }
        // this.apiService.currentCompanyChange.subscribe((data) => {
        //     console.log('currentCompany', data);
        //     this.currentCompany = data;

        //     this.outputItems[0].items.find(item => item.label == 'Actions').visible = this.currentCompany.organisation_id ? false : true;
        //     console.log(this.outputItems)
        // })


        // this.tags = this.apiService.tags;
        // this.apiService.tagsChanges.subscribe((data) => {
        //     this.tags = data;
        //     this.searchItems[0].items.find(item => item.label == 'Tags').badge = this.tags.length;
        // });

        // this.taxonomies = this.apiService.taxonomies;
        // this.apiService.taxonomiesChanges.subscribe((data) => {
        //     this.taxonomies = data;
        //     this.searchItems[0].items.find(item => item.label == 'Catégories').badge = this.taxonomies.length;
        // });

        // this.dates = this.apiService.dates;
        // this.apiService.datesChanges.subscribe((data) => {
        //     this.dates = data;
        //     this.searchItems[0].items.find(item => item.label == 'Dates').badge = this.dates.length;
        // });

        // this.companies = this.apiService.companies;
        // this.apiService.companiesChanges.subscribe((data) => {
        //     this.companies = data;
        //     this.adminItems[0].items.find(item => item.label == 'Bases').badge = this.companies.length;
        // });

        // this.users = this.apiService.users;
        // this.apiService.usersChanges.subscribe((data) => {
        //     this.users = data;
        //     this.adminItems[0].items.find(item => item.label == 'Utilisateurs').badge = this.users.length;
        // });

    }


    setMenu(){


        if (this.currentUser && this.currentUser.organisations.length === 0 && !this.currentUser.is_superadmin) {
            this.organisationItems = []
        } else {
            this.organisationItems = [
                {
                    label: 'Organisation',
                    items: [
                        {
                            label: 'Mon organisation',
                            icon: 'pi pi-fw pi-building',
                            routerLink: ['/pages/organisation'],
                            visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSupervisor') == "true") ? true : false,
                        },
                        {
                            label: 'Mes bases',
                            icon: 'pi pi-fw pi-database',
                            routerLink: ['/pages/bases'],
                        },
                        {
                            label: 'Mes bases de connaissance',
                            icon: 'pi pi-fw pi-database',
                            routerLink: ['/pages/knowledge-bases'],
                            visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSupervisor') == "true") ? true : false,
                        },
                        {
                            label: 'Mes utilisateurs',
                            icon: 'pi pi-fw pi-users',
                            routerLink: ['/pages/users'],
                            visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSupervisor') == "true") ? true : false,
                        },
                    ],
                }
            ]
        }

        if (localStorage.getItem('isSupervisor') == "true" && !localStorage.getItem('currentCompany') && localStorage.getItem('isSuperAdmin') != "1") {
            // this.dashboardItems = []
            // this.inputItems = []
            // this.outputItems = []
            // this.searchItems = []
            // this.adminItems = []
            return;
        }



        this.dashboardItems = [
            {
                label: 'Dashboard',
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/pages/home'],
                    },
                ],
            },
        ];

        this.adminItems = [
            {
                label: 'Administration',
                items: [
                    {
                        label: 'Organisations',
                        icon: 'pi pi-fw pi-building',
                        routerLink: ['/admin/organisations'],
                        visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false,
                    },
                    {
                        label: 'Votre profil',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/pages/profile'],
                    },
                    {
                        label: 'Bases',
                        icon: 'pi pi-fw pi-database',
                        routerLink: ['/admin/databases'],
                        visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false,
                    },
                    {
                        label: 'Tous les agents',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/admin/agents'],
                        visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false,
                    },
                    {
                        label: 'Tous les prompts',
                        icon: 'pi pi-fw pi-book',
                        routerLink: ['/admin/prompts'],
                        visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false,
                    },
                    {
                        label: 'Utilisateurs',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/admin/users'],
                        visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false,
                    },
                    {
                        label: 'Utilisateurs en attente',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/admin/waiting-users'],
                        visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isSuperAdmin') == "1") ? true : false,
                    },
                    {
                        label: 'Consommation',
                        icon: 'pi pi-fw pi-sliders-v',
                        routerLink: ['/admin/usage'],
                        visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isAdmin') == "true" || localStorage.getItem('isSupervisor') == 'true') ? true : false,
                    },
                    {
                        label: 'Réglages',
                        icon: 'pi pi-fw pi-cog',
                        routerLink: ['/admin/settings'],
                        visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isAdmin') == "true"  || localStorage.getItem('isSupervisor') == 'true') ? true : false,
                    },
                ],
            },
        ];



        this.inputItems = [
            {
                label: 'Input',
                items: [
                    {
                        label: 'Importer un document',
                        icon: 'pi pi-fw pi-download',
                        hasBadge: true,
                        badge: this.documentsProcessing ? this.documentsProcessing.length : 0,
                        routerLink: ['/pages/import'],
                    },
                    {
                        label: 'Import Zendesk',
                        icon: 'pi pi-fw pi-download',
                        hasBadge: true,
                        badge: this.documentsProcessing ? this.documentsProcessing.length : 0,
                        routerLink: ['/pages/import-zendesk'],
                        // visible: this.currentUser && (this.currentUser.is_superadmin || (this.currentCompany && this.currentCompany.organisation_id)) ? false : true,
                    },
                    {
                        label: 'Import Wordpress',
                        icon: 'pi pi-fw pi-download',
                        hasBadge: true,
                        badge: this.documentsProcessing ? this.documentsProcessing.length : 0,
                        routerLink: ['/pages/import-wp'],
                        // visible: this.currentUser && (this.currentUser.is_superadmin || (this.currentCompany && this.currentCompany.organisation_id)) ? false : true,
                    },
                ],
            },
        ];

        this.outputItems = [
            {
                label: 'Output',
                items: [
                    {
                        label: 'Poser une question',
                        icon: 'pi pi-fw pi-comments',
                        routerLink: ['/pages/chat'],
                    },
                    {
                        label: 'Actions',
                        icon: 'pi pi-fw pi-bolt',
                        routerLink: ['/pages/actions'],
                        // visible: this.currentUser && (this.currentUser.is_superadmin || (this.currentCompany && this.currentCompany.organisation_id)) ? false : true,
                    },
                    {
                        label: 'Agents',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/pages/agents'],
                        // visible: this.currentUser && (this.currentUser.is_superadmin || (this.currentCompany && this.currentCompany.organisation_id)) ? false : true,
                    },
                    {
                        label: 'Bibliothèque de prompts',
                        icon: 'pi pi-fw pi-book',
                        routerLink: ['/pages/prompts'],
                        // visible: this.currentUser && (this.currentUser.is_superadmin || (this.currentCompany && this.currentCompany.organisation_id)) ? false : true,
                    },
                    {
                        label: 'Bibliothèque d\'instructions',
                        icon: 'pi pi-fw pi-book',
                        routerLink: ['/pages/instructions'],
                        // visible: this.currentUser && (this.currentUser.is_superadmin || (this.currentCompany && this.currentCompany.organisation_id)) ? false : true,
                    },
                    {
                        label: 'Historique des conversations',
                        icon: 'pi pi-fw pi-history',
                        routerLink: ['/pages/conversations']
                    },
                    {
                        label: 'Documents générés',
                        icon: 'pi pi-fw pi-file-export',
                        routerLink: ['/pages/generated-documents']
                    },
                    {
                        label: 'Carte',
                        icon: 'pi pi-fw pi-map',
                        routerLink: ['/pages/map'],
                        // visible: this.currentUser && (this.currentUser.is_superadmin || (this.currentCompany && this.currentCompany.organisation_id)) ? false : true,
                    },
                ],
            },
        ];

        this.searchItems = [
            {
                label: 'Votre Narrathèque',
                items: [
                    {
                        label: 'Documents',
                        icon: 'pi pi-fw pi-file',
                        hasBadge: true,
                        badge: this.documentsDone ? this.documentsDone.length : 0,
                        routerLink: ['/pages/documents'],
                    },
                    {
                        label: 'Tags',
                        icon: 'pi pi-fw pi-tag',
                        routerLink: ['/pages/tags'],
                    },
                    {
                        label: 'Catégories',
                        icon: 'pi pi-fw pi-inbox',
                        routerLink: ['/pages/taxonomies'],
                    },
                    {
                        label: 'Dates',
                        icon: 'pi pi-fw pi-calendar',
                        routerLink: ['/pages/dates'],
                    },
                    {
                        label: 'Rechercher un document',
                        icon: 'pi pi-fw pi-search',
                        routerLink: ['/pages/search'],
                    },
                ],
            },
        ];
    }
}
